import React from "react";

const style = {
    fontSize:"25px",
    color:"#000",
    textTransform:"upperCase"
}

const MainHeading=({title,className,orangeheading,content,...restProps})=>{
    return(
         <>
           <h1 style={style} className={className} {...restProps} >
            <span style={{color:"#c82e21"}}>{orangeheading}</span> {title}
            <div dangerouslySetInnerHTML={{ __html: content }} />
            </h1>
         </>
    )
}
export {MainHeading};

